import { render } from "./Job.vue?vue&type=template&id=48f13bf2&scoped=true"
import script from "./Job.vue?vue&type=script&lang=js"
export * from "./Job.vue?vue&type=script&lang=js"

import "./Job.vue?vue&type=style&index=0&id=48f13bf2&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f13bf2"]])

export default __exports__